import { createGlobalStyle } from 'styled-components/macro';

const GlobalStyle = createGlobalStyle`
  :root {
    --primary: #8E2DB0;
    --orange: #F4A01D;
    --blue: #0B8AF7;
    --error: #B00020;
    --success: #388E3C;
    --system-bg: #F6F7F9;
    --text-grey-8: #262626;
    --text-grey-7: #464748;
    --text-grey-6: #656668;
    --text-grey-5: #A3A4A5;
    --text-grey-4: #C1C2C3;
    --text-grey-3: #E4E5E7;
    --text-grey-2: #F0F1F3;
    --text-grey-1: #F6F7F9;
  }

  #root {
    display: flex;
    height: 100vh;
    width: 100vw;
  }
`;

export default GlobalStyle;
